import React, { FC } from 'react';

import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { TeamOutlined } from '@ant-design/icons';

import MissingDetailsItem from '@/components/Common/MissingDetails/MissingDetailsItem';
import type { MissingRecipientEntry } from '@/components/Common/MissingDetails/types';
import policyStyles from '../PolicyStep.module.scss';

const nameSpace = 'uploadFiles.policyStep';

interface MissingDetailsSectionProps {
    missingRecipients: MissingRecipientEntry[];
    showPhones: boolean;
    showPasswords: boolean;
}

const MissingDetailsSection: FC<MissingDetailsSectionProps> = observer(({
    missingRecipients,
    showPhones,
    showPasswords,
}) => {
    const { t } = useTranslation();

    return (
        <div className={policyStyles['missing-details-section']}>
            <div className={policyStyles['section-header']}>
                <span className={policyStyles['section-title']}>
                    {t(`${nameSpace}.missingDetails`)}
                </span>
            </div>
            <div className={policyStyles['missing-details-list']}>
                {missingRecipients.map((entry) => (
                    <MissingDetailsItem
                        key={`${entry.email}-${entry.groupName || ''}`}
                        email={entry.email}
                        showPhones={showPhones}
                        showPasswords={showPasswords}
                        className={policyStyles['missing-details-item']}
                        inputsClassName={entry.groupName ? undefined : policyStyles['missing-details-inputs']}
                        emailClassName={policyStyles['missing-details-email']}
                        passwordBlockClassName={policyStyles['missing-details-password-block']}
                        renderLayout={entry.groupName
                            ? (inputs, emailLabel) => (
                                <div className={policyStyles['missing-details-item']}>
                                    <div className={policyStyles['missing-details-inputs']}>
                                        {inputs}
                                        <div className={policyStyles['missing-details-email-group']}>
                                            <div className={policyStyles['missing-details-email-row']}>
                                                {emailLabel}
                                            </div>
                                            <span className={policyStyles['missing-details-group-label']}>
                                                {t(`${nameSpace}.fromGroup`, 'from')}
                                                {' '}
                                                <TeamOutlined />
                                                {' '}
                                                {entry.groupName}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )
                            : undefined}
                    />
                ))}
            </div>
        </div>
    );
});

export default MissingDetailsSection;
